import axios from 'axios';

const api = axios.create({
  // Prefer a dev proxy (CRA "proxy" in `frontend/package.json`) so relative
  // requests like `/clients/...` become `http://localhost:5000/api/clients/...`.
  // If REACT_APP_API_URL is provided (e.g. production), use it as-is.
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ts_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes('/auth/login');
    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('ts_token');
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;